<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Articulo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <article-form v-if="isDataLoaded" :edit-all-fields="canEditAll" :article="article" @save="saveArticle" />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ArticleForm from './Forms/ArticleForm';
import swal from 'sweetalert2';

export default {
  name: 'ArticlesEdit',
  components: {
    RouteBreadCrumb,
    ArticleForm,
  },

  data() {
    return {
      article: null,
      isDataLoaded: false,
    };
  },

  computed: {
    canEditAll() {
      return this.$can('all', 'articles') && this.article.ordersCount === 0;
    },
  },

  created() {
    const articleId = this.$route.params.id;
    this.fetchArticle(articleId);
  },

  methods: {
    fetchArticle(id) {
      const params = {
        include: ['variety.crop', 'campaign.crops', 'ordersCount'],
      };

      this.$services
        .resource('articles')
        .show(id, params)
        .then((res) => res.data.data)
        .then((article) => {
          article.crop = article.variety.crop.id;
          article.campaign = article.campaign.id;
          article.variety = article.variety.id;
          this.article = article;
          this.isDataLoaded = true;
        });
    },

    saveArticle(changes) {
      this.$services
        .resource('articles')
        .update(this.article.id, changes)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El artículo fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'ArticlesList' }));
        });
    },
  },
};
</script>
